import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M31.6663 21.6673H21.6663H18.333H8.33301V18.334H18.333H21.6663H31.6663V21.6673Z", fill: "#090909" }));
export default SvgMinus;
